import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 丹麦
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Alle rettigheder forbeholdes',
    },
    auth: {
        login: 'Log ind',
        username: 'Brugernavn',
        username_placeholder: 'Indtast brugernavn',
        password: 'Adgangskode',
        password_placeholder: 'Indtast adgangskode',
        code: 'Bekræftelseskode',
        code_placeholder: 'Indtast bekræftelseskode',
        logout: 'Log ud',
        logout_success: 'Logget ud',
        day: 'dag',
        password_expiration: 'Adgangskoden er udløbet – opdater den venligst',
        expire: 'Dage tilbage før adgangskoden udløber',
        conseils:
            'Skal indeholde store bogstaver, små bogstaver, tal og specialtegn ({msg}). Adgangskoden skal være 8–16 tegn lang.',
        brand_Selection: 'Mærkevalg',
        unread_notices: 'Ulæste meddelelser',
        new_cases: 'Nye sager',
        unanswered_cases: 'Besvarelse mangler',
        overdue_cases: 'Forfaldne sager',
    },
    button: {
        query: 'Søg',
        editing_position: 'Redigér stilling',
        show_theme_editor: 'Vis/skjul temaredigering',
        change_password: 'Skift adgangskode',
        old_password: 'Gammel adgangskode',
        new_password: 'Ny adgangskode',
        confirm_password: 'Bekræft adgangskode',
        button: 'Knap',
        about: 'Om',
        back: 'Tilbage',
        go: 'OK',
        home: 'Forside',
        confirm: 'Bekræft',
        modify: 'Ændr',
        edit: 'Redigér',
        new: 'Ny',
        cancel: 'Annullér',
        close: 'Luk',
        search: 'Søg',
        reset: 'Nulstil',
        delete: 'Slet',
        add: 'Tilføj',
        collapse: 'Skjul',
        expand: 'Udvid',
        download_template: 'Download skabelon',
        batch_import: 'Masseimport',
        import: 'Importér',
        export: 'Eksportér',
        export_fail: 'Import fejlede',
        detailed: 'Detaljer',
        details: 'Detaljer',
        download: 'Download',
        toView: 'Vis',
        toViews: 'Vis billeder',
        uploadAttachments: 'Upload vedhæftede filer',
        selectFile: 'Vælg fil',
        fillingInstructions: 'Udfyldningsvejledning',
        release: 'Udgiv',
        release_recall: 'Tilbagetræk udgivelse',
        save: 'Gem',
        send: 'Send',
        tips: 'Tip',
        send_back: 'Send tilbage',
        examine: 'Gennemse',
        void: 'Annullér',
        more: 'Mere',
        refresh: 'Opdatér',
        selects: 'Vælg venligst',
        serial_number: 'Serienummer',
        upload_progress: 'Upload-fremdrift',
        invalid: 'Ugyldig',
        daily_record: 'Dagbog',
        operation_type: 'Handlings type',
        field_name: 'Feltnavn',
        edit_role: 'Redigér rolle',
        user_role: 'Vælg rolle',
        assignment_role: 'Rolle',
        post: 'Stilling',
        sending: 'Sender...',
        reset_password: 'Nulstil adgangskode',
        display_or_not: 'Vis eller ej',
        document: 'Dokument',
        specificTemplates: 'Specifikke skabeloner',
        transferOrder: 'Omdirigér sag',
        forwarding: 'Videresend',
        one_click_notification: 'Ét-klik-notifikation',
        english_export: 'Eksportér på engelsk',
        oneclick_download: 'Ét-klik-download',
        passwordmsga:
            'Skal indeholde store bogstaver, små bogstaver, tal og specialtegn (@\\$!_~\\&*)',
        passwordmsgb: 'Adgangskoden skal være 8–16 tegn lang',
        passwordmsgc: 'Må ikke være identisk med de sidste seks adgangskoder',
        export_file_list: 'Liste over eksporterede filer',
        personal_center: 'Personligt center',
        upload_list: 'Uploadliste',
        clear_completed: 'Ryd færdige',
    },
    radio: {
        enabled: 'Aktiveret',
        disabled: 'Deaktiveret',
        catalogue: 'Katalog',
        individual: 'Enkeltstående',
        all: 'Alle',
        yes: 'Ja',
        no: 'Nej',
    },
    dropdown: {
        close_others: 'Luk andre',
        close_right: 'Luk til højre',
        close_left: 'Luk til venstre',
    },
    table: {
        action: 'Handling',
        explain: 'Forklaring',
        fileName: 'Filnavn',
        size: 'Størrelse (MB)',
        uploader: 'Uploader',
        uploadTime: 'Uploadtidspunkt',
        system: 'System',
        caption: 'Titel',
        categorization: 'Kategorisering',
        link: 'Link',
        forwarding_time: 'Videresendt tidspunkt',
        forwarder: 'Videresender',
        send_to: 'Send til',
        mode: 'Tilstand',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} / Side`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `I alt ${named('number')} poster`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `I alt ${named('number')} biler`,
    },
    confirm: {
        confirm_deletion: 'Bekræft sletning?',
        confirm_void: 'Bekræft annullering?',
        confirm_release: 'Bekræft udgivelse?',
        ack: 'Bekræft',
        cancel: 'Annullér',
        non_records: 'Vælg mindst én post',
    },
    request: {
        failed_placeholder: 'Anmodning mislykkedes – serverfejl',
        success_placeholder: 'Anmodning lykkedes',
        auth: {
            login_success: 'Login lykkedes',
        },
        error: {
            '404': 'Stien findes ikke',
            '403': 'Utilstrækkelige rettigheder',
        },
    },
    page: {
        global: {
            page_search: 'Søg på side',
        },
        error: {
            not_found: 'Side ikke fundet',
            not_found_des: 'Der er intet her',
            auth_failed: 'Utilstrækkelige rettigheder',
            auth_failed_des: 'Adgang til denne side er forbudt',
            file_format_error: 'Ugyldigt filformat!',
            preview_failed: 'Forhåndsvisning mislykkedes! Filen er beskadiget!',
        },
        homepage: {
            homepage: homepage.homepage.daDK,
        },
        system: {
            menu: system.menu.daDK,
            dict: system.dict.daDK,
            dept: system.dept.daDK,
            role: system.role.daDK,
            user: system.user.daDK,
        },
        info: {
            announcement: Info.announcement.announcement.daDK,
            document: Info.document.document.daDK,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.daDK,
                recallActivity: tech.quality.recallActivity.daDK,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.daDK,
            },
            management: {
                inquiryOd: tech.management.inquiry.daDK,
                permission: tech.management.permission.daDK,
                onSiteSupportHq: tech.management.onSiteSupport.daDK,
                progHistoryHq: tech.management.progHistory.daDK,
                salesRecordHq: tech.management.salesRecord.daDK,
                vehicleInfoHq: tech.management.vehicleInfo.daDK,
                claimHq: tech.management.claim.daDK,
                filterHq: tech.management.filter.daDK,
                newCarlssue: tech.management.newCarIssue.daDK,
                newCarDefinition: tech.management.newCarDefinition.daDK,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.daDK,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.daDK,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.daDK,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.daDK,
        },
        statistics: statistics.inquiryStatistics.daDK,
        systemClassifyA: statistics.systemClassifyA.daDK,
        systemClassifyB: statistics.systemClassifyB.daDK,
        engineerStatistics: statistics.engineerStatistics.daDK,
        defectivePart: statistics.defectivePart.daDK,
        replyInquiryStatistics: statistics.replyInquiryStatistics.daDK,
        passRateStatistics: statistics.passRateStatistics.daDK,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.daDK,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.daDK,
        customsClearance135Rate: statistics.customsClearance135Rate.daDK,
        accumulatedClosureRate: statistics.accumulatedClosureRate.daDK,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.daDK,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.daDK,
    },
    validation: {
        common: {
            required: 'Dette felt er påkrævet',
            numeric: 'Skal være et heltal',
            decimal: 'Skal være et tal',
            positive_interger: 'Skal være et positivt heltal',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maksimalt ${named('number')} cifre`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Må ikke overstige ${named('number')} tegn`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Overskrider maksimalt antal tegn (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Mindst ${named('number')} tegn`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Skal være præcis ${named('number')} tegn`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Må ikke være større end ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Må ikke være mindre end ${named('number')}`,
            up_to_2_decimal_places: 'Maksimalt 2 decimaler',
            retain_up: 'Maksimalt 10 cifre før komma, op til 2 decimaler',
            retain_ups: 'Maksimalt 11 cifre før komma, op til 4 decimaler',
            input_number: 'Indtast venligst arabiske tal',
            only_number_a: 'Kun bogstaver eller tal tilladt',
            translate: 'Kun bogstaver tilladt',
            positive_integer: 'Udfyld mindst ét felt',
            at_least_one: 'Udfyld mindst ét',
        },
        tip: {
            incomplete_information: 'Informationen er ikke fuldstændig udfyldt',
        },
    },
    import: {
        template_file: 'Skabelonfil',
        browse: 'Gennemse',
        download_template: 'Download skabelon',
        no_file_selected: 'Ingen fil valgt',
        incorrect_file_type: 'Forkert filtype',
        exceed: 'Overskrider',
        upload_success: 'Upload lykkedes',
        upload_fail: 'Upload mislykkedes',
        again_upload:
            'Kun billeder i formaterne jpg, png, bmp eller gif kan uploades. Prøv venligst igen.',
        attachmentUpload: 'Upload vedhæftede filer',
        otherAttachmentUpload: 'Upload andre vedhæftede filer',
        supportedFormats: 'Understøttede formater',
        preview: 'Forhåndsvisning',
    },
    export: {
        noDataToExport: 'Ingen data at eksportere',
    },
    select: {
        all: 'Alle',
    },
    checkbox: {
        select_all: 'Vælg alle',
    },
    dialog: {
        error_message: 'Fejlmeddelelse',
        one_year: 'Maksimalt ét års dokumenter kan eksporteres ad gangen',
    },
    ymd: {
        year: 'år',
        month: 'måned',
        day: 'dag',
        week: 'uge',
        january: 'januar',
        february: 'februar',
        march: 'marts',
        april: 'april',
        may: 'maj',
        june: 'juni',
        july: 'juli',
        august: 'august',
        september: 'september',
        october: 'oktober',
        november: 'november',
        december: 'december',
    },
};
